import { Phone, FileText } from 'lucide-react';
import { COMPANY } from '../constants';
import { useLanguage } from '../i18n/LanguageContext';
import { Button } from './ui/button';

export const Hero = () => {
  const { t } = useLanguage();

  const handleScrollToDevis = (e) => {
    e.preventDefault();
    const element = document.getElementById('devis');
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="accueil"
      className="relative min-h-screen flex items-center justify-center pt-20 bg-gradient-to-b from-gray-50 to-white"
      data-testid="hero-section"
    >
      {/* Background Image with Light Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1637621896766-a4671cca06c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxzb3V0aCUyMG9mJTIwZnJhbmNlJTIwbW91bnRhaW4lMjByb2FkJTIwY2FyfGVufDB8fHx8MTc3NTIxMzkxN3ww&ixlib=rb-4.1.0&q=85"
          alt="Route de montagne dans le sud de la France"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/90 to-white/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#41DB23]/10 border border-[#41DB23]/30 rounded-full mb-6 sm:mb-8">
            <span className="w-2 h-2 bg-[#41DB23] rounded-full animate-pulse"></span>
            <span className="text-xs sm:text-sm font-bold tracking-[0.2em] uppercase text-[#41DB23]">
              {t.hero.badge}
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter text-gray-900 mb-4 sm:mb-6 leading-[0.95]">
            {t.hero.headline1}<br />
            <span className="text-[#41DB23]">{t.hero.headline2}</span>
          </h1>

          {/* Subtitle */}
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed max-w-2xl">
            <span dangerouslySetInnerHTML={{ __html: t.hero.subtitleHtml }} /><br />
            {t.hero.subtitleLine2}
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a href={COMPANY.phoneLink} data-testid="hero-phone-cta">
              <Button
                size="lg"
                className="w-full sm:w-auto bg-[#41DB23] text-white hover:bg-[#38C41E] font-bold uppercase tracking-wide px-6 sm:px-8 py-4 sm:py-6 text-base sm:text-lg rounded-md flex items-center justify-center gap-3 shadow-lg green-shadow-hover transition-all"
              >
                <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
                {t.callNow}
              </Button>
            </a>
            <Button
              size="lg"
              variant="outline"
              onClick={handleScrollToDevis}
              className="w-full sm:w-auto border-2 border-[#41DB23] text-[#41DB23] hover:bg-[#41DB23]/10 font-bold uppercase tracking-wide px-6 sm:px-8 py-4 sm:py-6 text-base sm:text-lg rounded-md flex items-center justify-center gap-3 transition-all"
              data-testid="hero-devis-cta"
            >
              <FileText className="w-5 h-5 sm:w-6 sm:h-6" />
              {t.hero.ctaQuote}
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="mt-8 sm:mt-12 flex flex-wrap items-center gap-3 sm:gap-4 text-sm text-gray-500">
            {t.hero.trust.map((item, i) => (
              <div key={i} className="flex items-center gap-2 bg-gray-50 px-3 py-1.5 rounded-full">
                <span className="text-[#41DB23]">&#10003;</span>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 hidden sm:block">
        <div className="w-6 h-10 border-2 border-[#41DB23]/50 rounded-full flex justify-center pt-2">
          <div className="w-1.5 h-3 bg-[#41DB23] rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
